import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { BaseApiService } from '@app/core/api/base-api.service';
import { AiModelDto } from '@stores/ai-models';

@Injectable({ providedIn: 'root' })
export class AiModelsService {
  private readonly api = inject(BaseApiService);
  private readonly apiVersion = 'v1';
  private readonly resourcePath = `${this.apiVersion}/tenants`;

  getAiModels(tenantUuid: string, page?: number, size?: number): Observable<AiModelDto[]> {
    type ApiAiModel = AiModelDto;
    let params = new HttpParams();
    if (page && size) {
      params.set('page', String(page)).set('size', String(size));
    }
    return this.api
      .get<readonly ApiAiModel[]>(`${this.resourcePath}/${tenantUuid}/aiModels`, { params })
      .pipe(map((arr) => (Array.isArray(arr) ? arr : [])));
  }
}
